import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Table, Form, InputGroup, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import { FaEdit, FaTrash, FaSearch, FaUserPlus, FaUser ,FaPlus} from 'react-icons/fa';

const Clients = () => {
    const [clients, setClients] = useState([]);
    const [search, setSearch] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [formData, setFormData] = useState({ nom: '', numerotele: '' });
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const token = localStorage.getItem('token');

    useEffect(() => {
        fetchClients();
    }, []);

const fetchClients = async () => {
  try {
    setLoading(true);
    const response = await axios.get('https://gce.iasoft.ma/api/clients', {
      headers: { Authorization: `Bearer ${token}` },
    });
    setClients(response.data);
  } catch (error) {
    console.error('Erreur lors du chargement des clients:', error);
  } finally {
    setLoading(false);
  }
};



    const handleAddClientClick = () => {
        setFormData({ nom: '', numerotele: '' });
        setSelectedClient(null);
        setShowModal(true);
    };

    const handleEditClick = (client) => {
        setFormData({
            nom: client.nom,
            numerotele: client.numerotele,
        });
        setSelectedClient(client);
        setShowModal(true);
    };


const handleSubmit = async () => {
  setIsSubmitting(true);
  try {
    if (selectedClient) {
      await axios.put(
        `https://gce.iasoft.ma/api/clients/${selectedClient.id}`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } else {
      await axios.post('https://gce.iasoft.ma/api/clients', formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
    }
    fetchClients();
    setShowModal(false);
  } catch (error) {
    console.error('Erreur:', error);
    alert(error.response?.data?.message || 'Une erreur est survenue.');
  } finally {
    setIsSubmitting(false);
  }
};

const handleDeleteClient = async (id) => {
  if (window.confirm('Êtes-vous sûr de vouloir supprimer ce client ?')) {
    try {
      await axios.delete(`https://gce.iasoft.ma/api/clients/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchClients();
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
    }
  }
};


    const filteredClients = clients.filter((client) =>
        client.nom.toLowerCase().includes(search.toLowerCase()) ||
        client.numerotele?.toString().includes(search)
    );

    return (
        <div className="client-list-container">
            <h1 className="page-title">   <FaUser /> Gestion des Clients</h1>   <br></br>

            <div className="header-section">
                <div className="action-buttons d-flex align-items-center">
                    <Button className="btn-custom-primary" onClick={handleAddClientClick}>
                     
                     <FaUserPlus className="me-2" />
                                Ajouter
                          
                    </Button>
                </div>
            </div>

            <div className="search-section mb-4">
                <InputGroup>
                    <InputGroup.Text>
                        <FaSearch />
                    </InputGroup.Text>
                    <Form.Control
                        type="text"
                        placeholder="Rechercher par nom ou téléphone..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </InputGroup>
            </div>

            <div className="table-responsive">
                <Table striped bordered hover className="client-table">
                    <thead className="table-header">
                        <tr>
                            <th style={{ width: '15%' }}>Actions</th>
                            <th>Nom</th>
                            <th>Téléphone</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="3" className="text-center">
                                    <Spinner animation="border" variant="primary" />
                                </td>
                            </tr>
                        ) : filteredClients.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="text-center">Aucun client trouvé</td>
                            </tr>
                        ) : (
                            filteredClients.map((client) => (
                                <tr key={client.id}>
                                    <td>
                                        <Button
                                            variant="outline-warning"
                                            size="sm"
                                            onClick={() => handleEditClick(client)}
                                            className="me-2"
                                        >
                                            <FaEdit />
                                        </Button>
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => handleDeleteClient(client.id)}
                                        >
                                            <FaTrash />
                                        </Button>
                                    </td>
                                    <td>{client.nom}</td>
                                    <td>{client.numerotele}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedClient ? 'Modifier Client' : 'Nouveau Client'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Nom</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Entrez le nom"
                                value={formData.nom}
                                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Téléphone</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Entrez le numéro de téléphone"
                                value={formData.numerotele}
                                onChange={(e) => setFormData({ ...formData, numerotele: e.target.value })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
      <Modal.Footer className="justify-content-center">
    <Button variant="secondary" onClick={() => setShowModal(false)}>
        Annuler
    </Button>
    <Button
        className="btn-custom-primary"
        onClick={handleSubmit}
        disabled={isSubmitting}
    >
        {isSubmitting ? (
            <>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                />
                {selectedClient ? 'Mise à jour...' : 'Ajout...'}
            </>
        ) : (
            selectedClient ? 'Mettre à jour' : 'Ajouter'
        )}
    </Button>
</Modal.Footer>

            </Modal>

            <style jsx global>{`
                .client-list-container {
                    padding: 2rem;
                    background-color:rgb(255, 255, 255);
                    min-height: 80vh;
                    width:50%;
                    margin-right:100%;
                }

                .header-section {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 2rem;
                    flex-wrap: wrap;
                    gap: 1rem;
                }

                .page-title {
                    color: #2c3e50;
                    font-weight: 600;
                    margin: 0;
                }

                .action-buttons {
                    display: flex;
                    gap: 1rem;
                }

                .search-section {
                    max-width: 500px;
                }

                .client-table {
                    background-color: white;
                    box-shadow: 0 0.5rem 1rem rgba(255, 255, 255, 0.1);
                }

                .table-header {
                    background-color: #2c3e50;
                    color: white;
                }

                .table-header th {
                    font-weight: 500;
                }

                .modal-content {
                    border-radius: 10px;
                    border: none;
                    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
                }

                .modal-header {
                    background-color: #2c3e50;
                    color: white;
                    border-radius: 10px 10px 0 0 !important;
                }

                .modal-title {
                    font-weight: 500;
                }

                .btn-outline-warning {
                    color: #ffc107;
                    border-color: #ffc107;
                }

                .btn-outline-warning:hover {
                    background-color: #ffc107;
                    color: #212529;
                }

                .btn-outline-danger {
                    color: #dc3545;
                    border-color: #dc3545;
                }

                .btn-outline-danger:hover {
                    background-color: #dc3545;
                    color: white;
                }

                .btn-custom-primary {
                    background-color: #2c3e50;
                    border-color: #2c3e50;
                    color: white;
                    
                }

                .btn-custom-primary:hover,
                .btn-custom-primary:focus {
                    background-color: #1a242f;
                    border-color: #1a242f;
                    color: white;
                }

                @media (max-width: 768px) {
                    .header-section {
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .action-buttons {
                        width: 100%;
                        flex-direction: column;
                    }

                    .action-buttons .btn {
                        width: 100%;
                        margin-bottom: 0.5rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default Clients;
